import React, { useState } from "react";
import { Link } from "react-router-dom";
import Herosection from "../Components/Herosection";
import { Card, Col, Container, Row } from "react-bootstrap";
import Wrapper from "../Components/Wrapper";
import { programNotes } from "../assets/API/data";
import Spinner from "../Components/Spinner";

function ProgramNotes() {
  const [languagesNotes] = useState(programNotes);
  const [loader] = useState(false);

  console.log("first", languagesNotes);
  return (
    <Wrapper>
      <Herosection title={languagesNotes?.title} />
      {loader ? (
        <Spinner />
      ) : (
        <div className="allSemWrapper text-center">
          <Container fluid="lg">
            <p className="subHeading fw-bold pt-5 mb-2" data-aos="fade-down">
              Nots
            </p>
            <h2 className="heading fw-bold text-light mt-3" data-aos="fade-up">
              {`${languagesNotes?.title}`}
            </h2>
            <div className="allCards">
              <Row>
                {languagesNotes?.languages?.map((item, index) => (
                  <Col
                    md="3"
                    key={item.id}
                    className="gy-4"
                    data-aos={item?.id <= 4 ? "zoom-out-down" : "zoom-out-up"}
                    data-aos-delay={item?.id * 200}
                    data-aos-duration="600"
                  >
                    <Card className="text-center p-lg-4 p-3 sem-subjects">
                      <Card.Img
                        className="mb-1"
                        variant="top"
                        src={item.img}
                        alt=""
                      />
                      <Card.Body className="d-flex flex-column justify-content-between">
                        <Card.Title className="text-white mb-2">
                          <h3 className="fw-semibold">{item?.heading}</h3>
                        </Card.Title>
                        <Link
                          to={`/notes/${item?.slug}`}
                          state={{ pdf: item?.link }}
                        >
                          <button className="nav-Button py-lg-2 px-lg-4 py-md-2 px-md-3 w-50">
                            View
                          </button>
                        </Link>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
            </div>
          </Container>
        </div>
      )}
    </Wrapper>
  );
}

export default ProgramNotes;
